import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import InformationPanel from './informationPanel';
import PricePanel from './pricePanel';
import discountTypes from '../../../shared/constants/discountType';
import {
  logProductClick,
  getProductFieldObject,
} from '../../utils/gtmLogUtils';

import './priceOfferListCard.scss';

const imageSizes = [
  {
    width: 115,
    height: 134,
    breakpoint: 768,
  },
  {
    width: 123,
    height: 184,
  },
];

const PriceOfferListCard = (props) => {
  const {
    index,
    priceOfferPackage,
    siteId,
    discountType,
    buttonText,
    isCharter,
  } = props;
  
  const {
    title,
    imageUrl,
    subtitle,
    rating,
    priceOfferListUspList,
    price,
    url,
    departureAirportCodeOrWvId,
    destinationAirportCodeOrWvId,
    hotelCode,
    hotelProductName,
  } = priceOfferPackage;

  const cardOrderIsEven = index % 2 !== 0;
  const priceOfferListCardClassnames = classNames('po-list-card', {
    'po-list-card--even': cardOrderIsEven,
  });

  const handleClick = (event) => {
    event.preventDefault();
    const gtmObject = getProductFieldObject(
      departureAirportCodeOrWvId,
      destinationAirportCodeOrWvId,
      hotelCode,
      price,
      hotelProductName,
      isCharter,
      index,
    );
    logProductClick(gtmObject);
    window.location = url;
  };

  return (
    <div className={priceOfferListCardClassnames}>
      <a
        href={url}
        rel="nofollow"
        onClick={(event) => handleClick(event)}
        aria-label={title}
      >
        <div className="po-list-link-layer" />
      </a>
      <CloudinaryPicture
        className="po-list-image-panel"
        img={{ cloudinaryUriTemplate: imageUrl }}
        alt={title}
        sizes={imageSizes}
        retina
        lazy
      />
      <div className="po-list-mobile-view-wrapper">
        <InformationPanel
          title={title}
          subtitle={subtitle}
          rating={rating}
          uspList={priceOfferListUspList}
        />
        <PricePanel
          price={price}
          siteId={siteId}
          discountType={discountType}
          buttonText={buttonText}
          url={url}
        />
      </div>
    </div>
  );
};

PriceOfferListCard.propTypes = {
  index: PropTypes.number.isRequired,
  priceOfferPackage: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    priceOfferListUspList: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string.isRequired,
    price: PropTypes.shape({
      original: PropTypes.number,
      discount: PropTypes.number,
      toPay: PropTypes.number,
      labels: PropTypes.shape({
        discount: PropTypes.string,
        priceDescription: PropTypes.string,
      }),
    }).isRequired,
    departureAirportCodeOrWvId: PropTypes.string,
    destinationAirportCodeOrWvId: PropTypes.string,
    hotelCode: PropTypes.string,
    hotelProductName: PropTypes.string,
  }).isRequired,
  siteId: PropTypes.number.isRequired,
  discountType: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  isCharter: PropTypes.bool.isRequired,
};

PriceOfferListCard.defaultProps = {
  discountType: discountTypes.showOrdinaryPrice,
};

export default PriceOfferListCard;
